import { alpha, Theme } from '@mui/material/styles';

export const modalBuyTokensStyles = (theme: Theme, isDark: boolean) => ({
  containerPaper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: 'auto',
    backgroundImage: isDark
      ? 'linear-gradient(106.41deg, rgb(24 27 52 / 92%) 7.3%, rgba(63, 95, 150, 0.33) 100%)'
      : 'linear-gradient(119.87deg, #dae8f9e8 0%, rgb(235 244 255 / 75%) 91.67%)',
    [theme.breakpoints.down('sm')]: {
      px: 2.5,
      width: '100%',
      height: 'auto',
      mx: 1.5,
      mt: 8
    }
  },
  container: {
    '& .MuiDialog-paper': {
      overflowY: 'scroll',
      height: 'auto',
      borderRadius: '12px',
      backdropFilter: 'blur(10px)',
      backgroundImage: isDark
        ? 'linear-gradient(106.41deg, rgb(24 27 52 / 92%) 7.3%, rgba(63, 95, 150, 0.33) 100%)'
        : 'linear-gradient(119.87deg, #dae8f9e8 0%, rgb(235 244 255 / 65%) 91.67%)',
      boxShadow: isDark
        ? '0px 8.6926px 43.463px rgba(0, 0, 0, 0.25)'
        : 'rgb(160 160 160 / 8%) 0px 11px 15px -7px, #007bff14 0px 24px 38px 3px, #14141426 0px 9px 46px 8px',
      [theme.breakpoints.down('md')]: {
        width: '560px',
        mx: 0
      },
      [theme.breakpoints.down('sm')]: {
        height: `calc(100% - 40px)`
      }
    },
    [theme.breakpoints.down('sm')]: {
      px: 2.5,
      width: '100%',
      height: 'auto'
    }
  },
  modalContainer: {
    px: 5,
    pb: 5,
    pt: 2,
    height: 'auto',
    '& .MuiBackdrop-root': {
      backgroundColor: 'transparent',
      zIndex: -1,
      backdropFilter: isDark ? 'blur(10px)' : 'blur(4px)'
    },
    [theme.breakpoints.down('md')]: {
      pt: 1
    },
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
      px: 0,
      pt: 0.5,
      pb: 3
    }
  },
  modalText: {
    textAlign: 'start',
    mb: 3.5,
    mt: 0
  },
  titleSection: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    wordBreak: 'break-all',
    pl: 5,
    pr: 2.5,
    pt: 1.5,
    [theme.breakpoints.down('md')]: {
      pl: 4
    },
    [theme.breakpoints.down('sm')]: {
      pl: 2,
      pt: 1,
      pr: 1
    }
  },
  dialogTitle: {
    wordBreak: 'break-all',
    pl: 0,
    fontVariationSettings: "'wght' 400",
    pb: 1.5,
    [theme.breakpoints.down('sm')]: {
      pr: 1
    }
  },
  continueButton: {
    mt: 3,
    '&.MuiButton-root': {
      border: 'none',
      background: theme.palette.primary.main,
      textAlign: 'center',
      borderRadius: '6px',
      color: '#fff',
      '&:hover': {
        backgroundColor: alpha(theme.palette.primary.main, 0.06),
        border: 'none',
        boxShadow: 'none',
        color: theme.palette.primary.main,
        '& .MuiSvgIcon-root': {
          color: theme.palette.primary.main
        }
      }
    }
  },
  modalTextClose: {
    cursor: 'pointer',
    textAlign: 'center',
    my: 2,
    fontVariationSettings: "'wght' 500",
    '&:hover': {
      color: alpha(theme.palette.primary.main, 0.5)
    }
  },
  closeIconButton: {
    mt: 0.5,
    [theme.breakpoints.down('sm')]: {
      pb: 0.5
    },
    '&. MuiButtonBase-root-MuiIconButton-root': {
      '&:hover': {
        backgroundColor: alpha(theme.palette.primary.main, 0.5)
      }
    }
  },
  closeIconSvg: {
    [theme.breakpoints.down('md')]: {
      fontSize: '22px'
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '20px'
    }
  },
  titleBox: { pb: 0.15 },
  containerBox: { pb: 1 },
  valueText: {
    color: isDark ? theme.palette.text.primary : theme.palette.primary.main,
    fontVariationSettings: isDark ? "'wght' 400" : "'wght' 500"
  },
  titleText: {
    color: isDark ? theme.palette.secondary.main : theme.palette.text.primary
  },
  fileIcon: { fontSize: '2rem', color: alpha(theme.palette.primary.main, 0.4) },
  subtitle: {
    fontVariationSettings: "'wght' 400",
    pt: 0.5
  },
  loader: {
    color: '#fff'
  },
  containerCard: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
});
